import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {

  get ({ commit, dispatch }, payload) {
    let url = 'api/reports/by-concept/' + payload.event.company_id + '/' + payload.event.date_start + '/' + payload.event.date_end
    let params = {
      'area_id': payload.event.area_id !== null ? payload.event.area_id : undefined,
      'project_id': payload.event.project_id !== null ? payload.event.project_id : undefined,
      'status_id': payload.event.status_id !== null ? payload.event.status_id : undefined,
      'category_id': payload.event.category_id !== null ? payload.event.category_id : undefined,
      'employee_id': payload.event.employee_id !== null ? payload.event.employee_id : undefined,
      'type': payload.event.type,
      'perPage': payload.event.context.pagination.rowsPerPage,
      'page': payload.event.context.page
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params })
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getDownload ({ commit, dispatch }, payload) {
    let url = 'api/reports/by-concept/' + payload.event.company_id + '/' + payload.event.date_start + '/' + payload.event.date_end
    let params = {
      'area_id': payload.event.area_id !== null ? payload.event.area_id : undefined,
      'project_id': payload.event.project_id !== null ? payload.event.project_id : undefined,
      'status_id': payload.event.status_id !== null ? payload.event.status_id : undefined,
      'category_id': payload.event.category_id !== null ? payload.event.category_id : undefined,
      'employee_id': payload.event.employee_id !== null ? payload.event.employee_id : undefined,
      'type': payload.event.type
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onGetDownload', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getLogged ({commit, dispatch}, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getProjects ({commit, dispatch}, payload) {
    let url = 'api/projects'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetProjects', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getAreas ({commit, dispatch}, payload) {
    let url = 'api/areas'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetAreas', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGet (state, payload) {
    let concepts = payload.response.data.data.concepts.data
    payload.event.context.conceptos = Array.from(concepts)
    payload.event.context.pageCount = payload.response.data.data.concepts.last_page
    let expensesItems = payload.response.data.data.expensesItemsByMonth

    if (expensesItems !== null) {
      let months = Object.getOwnPropertyNames(expensesItems)
      let newItems = []
      for (let i = 0; i < months.length; i++) {
        const item = months[i]
        if (item !== '0') {
          let temp = {
            month: parseInt(item),
            items: expensesItems[item]
          }
          newItems.push(temp)
        }
      }
      expensesItems = newItems
    }

    payload.event.context.expensesItems = expensesItems
    payload.event.context.dialog = false
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onGetProjects (state, payload) {
    let projects = payload.response.data.data
    payload.event.context.projects = projects
  },
  onGetAreas (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onGetDownload (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `ExpensesCategory-Detailed ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportsconcept.js